import { GenericObject } from "utility/misc";

export default function redirectToZapierWebhookConnectPage(
  orgStore: GenericObject,
  navigate: Function
): void {
  navigate("/environment/destinations/zapier_webhook/connect");
}
